import { ReportingSetData } from 'src/shared/models/pipeline-config/reporting-sets.models';
import { ApiResponse } from 'src/AngularJS/Models/api-response.model';

// Mirror of same-named object from ClearView WebPortal/AppCode/Api/Models/Pipeline/PipelineConfigurationModels.cs
export interface DataFeedReverseDependencies {
    DefinitionID: string;
    Hierarchies: string[];
    BaseFeeds: string[];
    Joins: string[];
    HierarchyReportingSets: string[];
    MetricAbvs: string[];
    CanDeleteEverything: boolean;
}

/**
 * Wraps a promise and its state. When the promise resolves, it marks itself as Finished
 */
export class CachedRequestPromise<T> {
    promise: Promise<ApiResponse<T>> = null;
    state: CacheState = CacheState.Unloaded;

    clear() {
        this.promise = null;
        this.state = CacheState.Unloaded;
    }

    setPromise(promise: Promise<ApiResponse<T>>) {
        this.promise = promise;
        this.state = CacheState.Loading;
        this.promise.then(() => this.markFinished());
    }

    markFinished() {
        this.state = CacheState.Finished;
    }
}

export const enum CacheState {
    Unloaded = 0,
    Loading = 1,
    Finished = 2,
}

// ClearView WebPortal/AppCode/Api/Models/Pipeline/PipelineConfigurationModels.cs
/** Result of the Simulate Raw Data and Simulate Reporting Set endpoints */
export interface SimulatePipelineResult {
    DefinitionName: string;
    SimulatedData: ReportingSetData;
}

// Mirror of same-named object from ClearView WebPortal/AppCode/Api/Controllers/Pipeline/PipelineConfigurationModels.cs
export interface PipelineConfigPermissionsModel {
    HierarchyConfiguration: boolean;
    MetricConfiguration: boolean;
    RawDataConfiguration: boolean;
    ReportingSetConfiguration: boolean;
    IsAdmin: boolean;
}

// Mirror of same-named object from ClearView WebPortal/AppCode/Api/Models/Pipeline/PipelineConfigurationModels.cs
export interface FailedProcessReport {
    ImportId: string,
    FeedName: string,
    SourceSystem: string,
    ReportingSetID: string,
    ProcessStartTime: Date,
    Reason: string,
}
